import { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from 'react';
import type { ComposerContextView } from './contracts';
import { useApplicationChat } from '../context';

const ComposerContext = createContext<ComposerContextView | null>(null);
export const ComposerProvider = ({ children }: { children?: ReactNode }) => {
  const { viewModel } = useApplicationChat();
  const sessionId = viewModel.sessionList.activeSessionId;
  const [composerModeKey, setComposerModeKey] = useState('auto');
  const [savedIntakeCanvasContent, setSavedIntakeCanvasContent] = useState('');
  useEffect(() => {
    setSavedIntakeCanvasContent('');
  }, [sessionId]);
  const value = useMemo(() => ({ composerModeKey, setComposerModeKey,
    savedIntakeCanvasContent, setSavedIntakeCanvasContent,
  }), [composerModeKey, savedIntakeCanvasContent]);
  return <ComposerContext.Provider value={value}>{children}</ComposerContext.Provider>;
};
export const useComposerContext = (): ComposerContextView => {
  const value = useContext(ComposerContext);
  if (!value) throw new Error('Product composer context requires the application provider');
  return value;
};
